import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import moment from 'moment-timezone'
import 'moment/locale/fr'
import 'moment/locale/en-gb'
import 'moment/locale/it'
import 'moment/locale/es'
import 'moment/locale/hu'
import 'moment/locale/ro'
import 'moment/locale/bg'
import 'moment/locale/nl'
import 'moment/locale/de'
import 'moment/locale/zh-cn'
import { MomentOption } from './momentUtils'
import './relativeTime'

export const FormatType = {
	DATE: 'date'
}

i18n
	// load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
	// learn more: https://github.com/i18next/i18next-http-backend
	.use(Backend)
	.use(LanguageDetector)
	.use(initReactI18next)
	// for all options read: https://www.i18next.com/overview/configuration-options
	.init({
		ns: ['dictionary'],
		defaultNS: 'dictionary',
		fallbackLng: 'en',
		debug: process.env.REACT_APP_ENABLE_LOG_TRANSLATION === 'true',
		interpolation: {
			escapeValue: false, // not needed for react as it escapes by default
			format: function (value, option) {
				const defaultValue = value
				moment.tz.guess()
				if (value) {
					if (option?.type === FormatType.DATE) {
						value = new Date(value)
					}
					if (option?.date) {
						option.date = new Date(option.date)
						if (!(option.date instanceof Date)) {
							return null
						}
					}
					if (value instanceof Date) {
						if (option?.format) {
							return moment(value).format(option.format)
						}
						switch (option?.momentOption) {
							case MomentOption.FROM:
								return moment(value).from(option.date)
							case MomentOption.TO:
								return moment(value).to(option.date)
							case MomentOption.DURATION:
								return moment.duration(moment(value).diff(moment(option.date))).humanize()
							case MomentOption.FROM_NOW:
								return moment(value).fromNow()
							case MomentOption.TO_NOW:
								return moment(value).toNow()
							case MomentOption.DURATION_NOW:
								return moment.duration(moment(value).diff(moment(Date.now()))).humanize()
							default:
								break
						}
					}
				}
				return defaultValue
			}
		},
		backend: {
			loadPath: './locales/{{ns}}.{{lng}}.json'
		},
		react: {
			//bindI18n: 'languageChanged',
			//bindI18nStore: '',
			//transEmptyNodeValue: '',
			//transSupportBasicHtmlNodes: true,
			//transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
			useSuspense: false
		}
	})

i18n.on('languageChanged', function (lng) {
	moment.locale(lng)
})

export default i18n
